import getFormattedDollarPrice from './getters/getFormattedDollarPrice';

export const getPriceLabel = (text: string, price: number) => `${text} ${getFormattedDollarPrice(price)}`;
